import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Areas", href: "#areas" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    api
      .get("/site-images")
      .then((res) => setLogo(res.data?.logo || null))
      .catch(() => setLogo(null));
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_4px_24px_-12px_rgba(15,58,90,0.18)]"
          : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          {logo ? (
            <img
              src={logo}
              alt="AZ Pools"
              className="h-10 w-auto max-w-[180px] object-contain"
            />
          ) : (
            <>
              <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#0F3A5A] text-white font-display font-bold text-lg">
                AZ
              </span>
              <span className="font-display font-semibold text-xl tracking-tight text-[#0F3A5A]">
                AZ Pools
              </span>
            </>
          )}
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm font-medium text-slate-700 hover:text-[#0F3A5A] transition-colors"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:9543288083"
            className="hidden md:inline-flex items-center gap-2 bg-[#00B4D8] hover:bg-[#0096B4] text-white px-5 py-2.5 rounded-full text-sm font-semibold shadow-md hover:shadow-lg transition-all"
            data-testid="header-call-btn"
          >
            <Phone className="w-4 h-4" />
            954-328-8083
          </a>
          <button
            className="lg:hidden p-2 rounded-lg text-[#0F3A5A]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200 px-6 py-4 space-y-3" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block py-2 text-base font-medium text-slate-700"
            >
              {n.label}
            </a>
          ))}
          <a
            href="tel:9543288083"
            className="block bg-[#00B4D8] text-white text-center py-3 rounded-full font-semibold mt-3"
          >
            Call 954-328-8083
          </a>
        </div>
      )}
    </header>
  );
}
